/* eslint-disable */ 
import React from 'react';
import './components.css';
import { Link } from 'react-router-dom';

const Exercise = (props) => {
    return (
        <div className='card-2025 rounded-2xl p-3 hover:shadow-elev transition-all duration-200 animate-slideUp' tabIndex={1}>
            <Link to={`/workouts/${props.workoutId}/exercises/${props.id}`} className='no-underline text-zinc-900 dark:text-zinc-100'>
                <p>{props.title}</p>
            </Link>
        </div>
    )
}

export default Exercise